<div class="expense-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Costo
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 expense-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Nombre </mat-label>
              <input matInput name="name" formControlName="name" type="text" #nameInput [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['name']?.errors?.['required']">
              Nombre Obligatorio
            </mat-error>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Descripción </mat-label>
              <input matInput name="description" formControlName="description" type="text" #descriptionInput
                [readonly]="readOnly">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Costo {{curr}} </mat-label>
              <input matInput name="amount" formControlName="amount" type="number" [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['amount'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['amount']?.errors?.['required']">
              Costo Obligatorio
            </mat-error>
            <mat-error *ngIf="submitted && f['amount']?.errors?.['min']">
              Costo debe ser Mayor o Igual a Cero
            </mat-error>
          </div>
        </div>

        <div class="row" *ngIf="expense._id && isDev">
          <div class="col-3">
            <label>
              Borrada? <br>
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" [disabled]="readOnly">
            </label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput placeholder="Id" type="text" [value]="expense._id" readonly>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="!readOnly">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link" (click)="cancelSubmit(); "
              *ngIf="!readOnly">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>